export default __webpack_public_path__ + "static/media/V450_SOV.4b606105.pdf";